module.exports = __webpack_public_path__ + "static/mreavesxlsannarr-020415006EmigreWebOnly-063ae7390e8828ce23d823a50ba2afb6.woff2";